import apiClient from '../apiClient';
import { POST_ACCOMODATION_URL } from '../apiUrl';

const postAccomodationApi = data => {
  return apiClient.post(POST_ACCOMODATION_URL, data);
};

export default postAccomodationApi;
